import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@folio/stripes-components';

const VisionModelSelector = ({ selectedModel, onModelChange, disabled }) => {
  const modelOptions = [
    { value: '', label: 'Default (Ollama - Qwen 2.5 VL 3B)' },
    {
      label: 'Ollama (Local)',
      options: [
        { value: 'ollama|qwen2.5vl:3b', label: 'Qwen 2.5 VL 3B' },
        { value: 'ollama|qwen3.8:27b', label: 'Qwen 3.8 27B' },
        { value: 'ollama|minicpm-v:latest', label: 'MiniCPM-V' },
      ],
    },
    {
      label: 'AWS Bedrock',
      options: [
        { value: 'bedrock|qwen.qwen3-vl-235b-a22b', label: 'Qwen 3 VL 235B' },
        {
          value: 'bedrock|anthropic.claude-3-5-sonnet-20241022-v2:0',
          label: 'Claude 3.5 Sonnet',
        },
      ],
    },
    {
      label: 'Groq',
      options: [
        { value: 'groq|qwen/qwen3.8-27b', label: 'Qwen 3.8 27B' },
        {
          value: 'groq|meta-llama/llama-4-maverick-17b-128e-instruct',
          label: 'Llama 4 Maverick',
        },
        { value: 'groq|openai/gpt-oss-120b', label: 'GPT OSS 120B' },
      ],
    },
  ];

  return (
    <Select
      value={selectedModel}
      onChange={(e) => onModelChange(e.target.value)}
      disabled={disabled}
      marginBottom0
    >
      {modelOptions.map((group, index) => {
        if (group.options) {
          return (
            <optgroup key={index} label={group.label}>
              {group.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </optgroup>
          );
        }
        return (
          <option key={group.value} value={group.value}>
            {group.label}
          </option>
        );
      })}
    </Select>
  );
};

VisionModelSelector.propTypes = {
  selectedModel: PropTypes.string.isRequired,
  onModelChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

VisionModelSelector.defaultProps = { disabled: false };

export default VisionModelSelector;
